<template>
    <div>
        <p>L'organisateur vous propose de vous inscrire sur la liste d'attente pour un parcours. Si un
            participant se désiste et met son dossard en vente, vous serez notifié par email. Votre position dans la
            liste d'attente est définie par l'ordre d'inscription.</p>
        <p>
            Grace au lien fourni dans le mail, vous pourrez racheter le dossard. <b>Ce lien est valable 24 heures</b>.
            Passé ce
            délai, le lien sera envoyé au suivant participant de la liste d'attente, et vous perdrez votre place. Vous
            aurez la possibilité de vous réinscrire sur la liste d'attente, si vous le souhaitez. </p>
        <div class="text-h6 font-weight-bold text-darkblue mb-4">Vous souhaitez:</div>
        <v-tabs bg-color="darkblue" fixed-tabs v-model="tab">
            <v-tab value="verify">Vérifier votre position</v-tab>
            <v-tab value="register">Vous inscrire en liste d'attente</v-tab>

        </v-tabs>
        <v-form ref="verify_form" @submit.prevent>
            <div class="field_label mt-2">Votre email</div>
            <v-text-field v-model="mail" :rules="[$formRules.required, $formRules.email]"></v-text-field>
            <div class="field_label mt-2">Parcours souhaité</div>
            <v-select :items="select_list_courses" item-title="title" item-value="value" v-model="selected_course"
                :rules="[$formRules.required]"></v-select>
        </v-form>
        <v-tabs-window v-model="tab">

            <v-tabs-window-item value="verify">
                <div class="d-flex justify-center">
                    <SportipsButton icon="mdi-check" actionButton @onClick="handleVerify">Vérifier votre
                        position
                    </SportipsButton>
                </div>
            </v-tabs-window-item>
            <v-tabs-window-item value="register">
                <div class="d-flex justify-center">
                    <SportipsButton icon="mdi-account-clock-outline" action-button @onClick="handleRegister">
                        S'inscrire en liste
                        d'attente
                    </SportipsButton>
                </div>
            </v-tabs-window-item>
        </v-tabs-window>

        <!-- Dialog: Vérifier votre position -->
        <v-dialog v-model="verifyDialog" max-width="520">
            <v-card>
                <v-card-title class="text-h6">
                    Vérification de votre position
                </v-card-title>
                <v-card-text>
                    <div v-if="verifyResult && verifyResult.id">
                        <div v-if="verifyResult.mail_send == '1'">
                            Vous avez atteint le haut de la liste d'attente. Un email vous a déjà été envoyé pour
                            racheter un dossard dans un délai de 24 heures. Vous ne recevrez pas d'autres emails pour
                            cette course de notre part.
                        </div>
                        <div v-else>
                            Vous êtes bien inscrit sur la liste d'attente pour ce parcours.
                            <br />
                            <div v-if="verifyResult.mail != mail">
                                Vous êtes inscrit sur la liste d'attente dans <b>l'équipe de {{ verifyResult.mail
                                    }}</b>, la notification en cas de mise en vente sera envoyée à cette adresse.
                            </div>
                            Position actuelle: <strong>{{ verifyResult.position }}</strong>
                        </div>

                    </div>
                    <div v-else>
                        Vous n'êtes pas encore inscrit sur la liste d'attente pour ce parcours.
                        <br />
                        Vous pouvez vous inscrire dès maintenant.
                    </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn variant="text" @click="verifyDialog = false">Fermer</v-btn>
                    <SportipsButton v-if="!verifyResult || !verifyResult.id" action-button
                        @click="verifyDialog = false; tab = 'register'; handleRegister()">
                        S'inscrire maintenant
                    </SportipsButton>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog: Inscription en liste d'attente -->
        <v-dialog v-model="registerDialog" max-width="520">
            <v-card>
                <v-card-title class="text-h6">
                    Inscription en liste d'attente
                </v-card-title>
                <v-card-text>
                    <div v-if="registerResult">
                        Votre inscription a été prise en compte.
                        <br />
                        Position actuelle: <strong>{{ registerResult.position }}</strong>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn color="primary" @click="registerDialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PublicService from "@/services/public.service";
export default {
    name: 'BourseDossardListListeAttente',
    computed: {
        ...mapStores(useMainStore),
        select_list_courses() {
            if (!this.mainStore.module.courses.has_courses) {
                return [];
            }
            let list_courses = this.mainStore.module.courses.list.map(course => {
                return {
                    title: course.nom,
                    value: course.id,
                }
            });
            list_courses.unshift({
                title: 'Sélectionner un parcours',
                value: null,
            });

            return list_courses;
        }
    },

    data() {
        return {
            tab: "verify",
            mail: "",
            selected_course: null,
            verifyDialog: false,
            registerDialog: false,
            verifyResult: null,
            registerResult: null,
        }
    },

    methods: {
        async handleVerify() {
            if (!await this.verifyForm()) {
                return;
            }
            const id_module = this.mainStore.module.id;
            let request = await PublicService.verifyListeAttente(this.mail, this.selected_course, id_module, false);
            if (!request) {
                this.mainStore.notification.send("Erreur lors de la vérification de votre position", "error");
                return;
            }
            this.verifyResult = request;
            this.verifyDialog = true;

        },
        async handleRegister() {
            if (!await this.verifyForm()) {
                return;
            }
            const id_module = this.mainStore.module.id;
            let request = await PublicService.verifyListeAttente(this.mail, this.selected_course, id_module, true);
            if (!request) {
                this.mainStore.notification.send("Erreur lors de l'inscription en liste d'attente", "error");
                return;
            }
            this.registerResult = request;
            this.registerDialog = true;
        },
        async verifyForm() {

            const form = this.$refs.verify_form;
            if (!form) {

                return false;
            }
            const validationResult = await form.validate();
            if (!validationResult || validationResult.valid === false) {
                return false;
            }
            return true;
        },
    },

    mounted() {
        if (this.mainStore.module.courses.has_courses) {
            this.selected_course = this.select_list_courses[0].value;
        }


    },
}
</script>

<style lang="scss" scoped></style>